module.exports = __webpack_public_path__ + "img/zs14.72bc0793.jpg";